import { BaseFetch } from "../main-model"
export default class HomeroomTeacherModel extends BaseFetch {
    getHomeroomTeacherBy = (data) =>
    this.authFetch({
      url: "homeroom-teacher/getHomeroomTeacherBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getHomeroomTeacherById = (data) =>
    this.authFetch({
      url: "homeroom-teacher/getHomeroomTeacherById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertHomeroomTeacher = (data) =>
    this.authFetch({
      url: "homeroom-teacher/insertHomeroomTeacher",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateHomeroomTeacherById = (data) =>
    this.authFetch({
      url: "homeroom-teacher/updateHomeroomTeacherById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteHomeroomTeacherById = (data) =>
    this.authFetch({
      url: "homeroom-teacher/deleteHomeroomTeacherById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getHomeroomStudentBy = (data) =>
    this.authFetch({
      url: "homeroom-teacher/getHomeroomStudentBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
